import {
  faHeader,
  faImage,
  faLayerGroup,
  faLink,
  faQuoteLeft,
  faPalette,
  faRocket,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, message, Modal, Segmented } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoaderState,
  getUserDetailsFromReducer,
  updateLoader,
  updateUserDetailsInReducer,
} from "Store/reducers/Auth/AuthSlice";
import { API } from "aws-amplify";
import useCustomBreakpoints from "Hooks/UseCustomBreakPoints";
import Lottie from "react-lottie";
import animationData from "Assets/LottieAnimations/lottie-animations.json";
import ShareLinks from "./ShareLinks";
import { AddSocialMedia } from "./AddSocialMedia";
import { CustomTheme } from "./CustomTheme";
import "./ActionBar.css";
import { ActionBarBasicTab } from "./ActionBarBasicTab";
import { ActionBarContentTab } from "./ActionBarContentTab";
import { ActionBarDesignTab } from "./ActionBarDesignTab";

export const ActionBar = ({ onAddCard }) => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const isLoading = useSelector(getLoaderState);
  const [addSocialMediaModel, setAddSocialMediaModel] = useState(false);
  const [showLottie, setshowLottie] = useState(false);
  const [addShareModel, setAddShareModel] = useState(false);
  const [isCustomThemeOpen, setIsCustomThemeOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Basic");

  const buttons = [
    {
      icon: faLink,
      text: "Add Links ",
      onClick: () => setAddSocialMediaModel(!addSocialMediaModel),
    },
    {
      icon: faHeader,
      text: "Add Title",
      onClick: () => onAddCard("title"),
    },
    {
      icon: faQuoteLeft,
      text: "Add Text",
      onClick: () => onAddCard("discription"),
    },
    {
      icon: faImage,
      text: "Add Image",
      onClick: () => onAddCard("image"),
    },
    {
      icon: faLayerGroup,
      text: "Add Card",
      onClick: () => onAddCard("card"),
    },
  ];

  const url = `https://inprofile.co/${userDetails?.username}`;
  const dispatch = useDispatch();

  const handlePublish = async () => {
    try {
      setshowLottie(true);
      if (!userDetails?.isDraft) {
        handleGoToURL();
        return;
      }
      dispatch(updateLoader(true));
      await API.get("REST", "/publish");
      message.success("Your Profile is published!");
      dispatch(updateUserDetailsInReducer({ ...userDetails, isDraft: false }));
      // setAddShareModel(prev => !prev);
      return true;
    } catch (error) {
      message.error("Unable to publish your profile at this moment!!!");
      return false;
    } finally {
      dispatch(updateLoader(false));
      setshowLottie(false);
    }
  };

  const handleGoToURL = () => {
    window.open(url);
  };

  const screen = useCustomBreakpoints();
  const smallScreen = screen.xs || screen.sm || screen.md || screen.lg;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div>
      {showLottie && (
        <div className="lottie-animation fixed z-10 inset-0 flex justify-center items-center ">
          <div className="w-full md:w-1/2 h-full">
            <Lottie options={defaultOptions} height={"100%"} width={"100%"} />
          </div>
        </div>
      )}

      <div
        className={
          `actionbar-container ` +
          (smallScreen ? "actionbar-bottom-center" : "actionbar-right-vertical")
        }
        style={
          !smallScreen
            ? {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 350,
                padding: "1.5rem 1rem",
                height: "fit-content",
                maxHeight: "90vh",
                overflowY: "auto",
              }
            : {}
        }
      >
        {/* Only show on large screens: vertical action buttons */}
        {!smallScreen && (
          <>
            <div className="mb-4">
              <Button
                onClick={
                  userDetails?.isDraft
                    ? handlePublish
                    : () => setAddShareModel(!addShareModel)
                }
                type="primary"
                className={`px-3 py-2 focus:outline-none w-full whitespace-nowrap flex items-center justify-center gap-2 bg-[#11111A] text-white font-semibold text-sm rounded-md border-none`}
                loading={isLoading}
              >
                <FontAwesomeIcon
                  icon={
                    isLoading && !userDetails?.isDraft ? faShareNodes : faRocket
                  }
                  className="mr-2 text-sm"
                />
                {!userDetails?.isDraft
                  ? "Share Profile"
                  : isLoading
                  ? "Saving.."
                  : "Publish Profile"}
              </Button>
            </div>
            <div className="border-b border-gray-200 mb-4" />
            <Segmented
              options={[
                { label: "Basic", value: "Basic" },
                { label: "Content", value: "Content" },
                { label: "Design", value: "Design" },
              ]}
              value={activeTab}
              onChange={setActiveTab}
              size="middle"
              block
              shape="round"
              className="actionbar-tabs-xs mb-4"
            />
            <div className="flex-1 overflow-hidden flex flex-col gap-3">
              {activeTab === "Basic" && <ActionBarBasicTab />}
              {activeTab === "Content" && (
                <ActionBarContentTab buttons={buttons} />
              )}
              {activeTab === "Design" && (
                <ActionBarDesignTab
                  setIsCustomThemeOpen={setIsCustomThemeOpen}
                />
              )}
            </div>
          </>
        )}
        {/* Mobile/bottom bar: keep original order */}
        {smallScreen && (
          <>
            {userDetails?.isDraft ? (
              <div className="h-2 w-2 rounded-full bg-primary animate-pulse"></div>
            ) : null}
            <button
              onClick={
                userDetails?.isDraft
                  ? handlePublish
                  : () => setAddShareModel(!addShareModel)
              }
              className="actionbar-btn publish-btn"
              disabled={isLoading}
            >
              <span className="actionbar-btn-inner">
                <FontAwesomeIcon
                  icon={userDetails?.isDraft ? faRocket : faShareNodes}
                  className="actionbar-btn-icon"
                />
                <span className="actionbar-btn-text">
                  {!userDetails?.isDraft
                    ? "Share"
                    : isLoading
                    ? "Saving.."
                    : "Publish"}
                </span>
              </span>
            </button>
            {/* {(smallScreen || typeof smallScreen === "undefined") && (
              <div className="w-[2px] h-4 rounded-lg bg-gray-500"></div>
            )} */}
            {buttons.map((item, index) => (
              <div key={index}>
                <button className="actionbar-btn" onClick={item?.onClick}>
                  <span className="actionbar-btn-inner">
                    <FontAwesomeIcon
                      icon={item?.icon}
                      className="actionbar-btn-icon"
                    />
                    <span className="actionbar-btn-text">
                      {item?.text.replace("Add ", "")}
                    </span>
                  </span>
                </button>
              </div>
            ))}

            <button
              className="actionbar-btn"
              onClick={() => setIsCustomThemeOpen(true)}
            >
              <span className="actionbar-btn-inner">
                <FontAwesomeIcon
                  icon={faPalette}
                  className="actionbar-btn-icon"
                />
                <span className="actionbar-btn-text">Theme</span>
              </span>
            </button>
          </>
        )}

        {/* Custom Theme Modal */}
        <CustomTheme
          isCustomThemeOpen={isCustomThemeOpen}
          setIsCustomThemeOpen={setIsCustomThemeOpen}
        />

        <Modal
          title="Share Inprofile"
          open={addShareModel}
          footer={null}
          onCancel={() => setAddShareModel(false)}
          centered
        >
          <ShareLinks />
        </Modal>
        <AddSocialMedia
          addSocialMediaModel={addSocialMediaModel}
          setAddSocialMediaModel={setAddSocialMediaModel}
        />
      </div>
    </div>
  );
};
